import { Col, Row } from "@/components/customComponents";

import ChartSkeleton from "./ChartSkeleton";
import Pulse from "./Pulse";
import SummaryCardsSkeleton from "./SummaryCardsSkeleton";
import TableSkeleton from "./TableSkeleton";

const FILTER_COUNT = 4;

const OverviewSkeleton = () => (
  <Col className="mx-auto w-full max-w-7xl gap-6 px-3 py-4 sm:gap-8 sm:px-4 sm:py-6">
    <Pulse className="h-8 w-64" />
    <Row className="gap-2">
      {Array.from({ length: FILTER_COUNT }).map((slot, i) => (
        <Pulse key={i} className="h-8 w-14 rounded-full" />
      ))}
    </Row>
    <SummaryCardsSkeleton />
    <ChartSkeleton />
    <TableSkeleton />
  </Col>
);

export default OverviewSkeleton;
